__turbopack_context__.v({
  "animateFadeInLeft": "ComparisonSection-module__WK8rNa__animateFadeInLeft",
  "animateFadeInRight": "ComparisonSection-module__WK8rNa__animateFadeInRight",
  "animateFadeInUp": "ComparisonSection-module__WK8rNa__animateFadeInUp",
  "animateScaleIn": "ComparisonSection-module__WK8rNa__animateScaleIn",
  "boringAccount": "ComparisonSection-module__WK8rNa__boringAccount",
  "boringAccountBalance": "ComparisonSection-module__WK8rNa__boringAccountBalance",
  "boringAccountBalanceNegative": "ComparisonSection-module__WK8rNa__boringAccountBalanceNegative",
  "boringAccountBalanceZero": "ComparisonSection-module__WK8rNa__boringAccountBalanceZero",
  "boringAccountName": "ComparisonSection-module__WK8rNa__boringAccountName",
  "boringApp": "ComparisonSection-module__WK8rNa__boringApp",
  "boringAvatar": "ComparisonSection-module__WK8rNa__boringAvatar",
  "boringHeader": "ComparisonSection-module__WK8rNa__boringHeader",
  "boringLogo": "ComparisonSection-module__WK8rNa__boringLogo",
  "boringNotice": "ComparisonSection-module__WK8rNa__boringNotice",
  "boringNoticeAmount": "ComparisonSection-module__WK8rNa__boringNoticeAmount",
  "boringNoticeContent": "ComparisonSection-module__WK8rNa__boringNoticeContent",
  "boringNoticeIcon": "ComparisonSection-module__WK8rNa__boringNoticeIcon",
  "boringNoticeTitle": "ComparisonSection-module__WK8rNa__boringNoticeTitle",
  "boringSection": "ComparisonSection-module__WK8rNa__boringSection",
  "boringSectionTitle": "ComparisonSection-module__WK8rNa__boringSectionTitle",
  "comparisonGrid": "ComparisonSection-module__WK8rNa__comparisonGrid",
  "comparisonSection": "ComparisonSection-module__WK8rNa__comparisonSection",
  "coralImage": "ComparisonSection-module__WK8rNa__coralImage",
  "coveScreenshot": "ComparisonSection-module__WK8rNa__coveScreenshot",
  "decorationImage": "ComparisonSection-module__WK8rNa__decorationImage",
  "delay1": "ComparisonSection-module__WK8rNa__delay1",
  "delay2": "ComparisonSection-module__WK8rNa__delay2",
  "delay3": "ComparisonSection-module__WK8rNa__delay3",
  "delay4": "ComparisonSection-module__WK8rNa__delay4",
  "delay5": "ComparisonSection-module__WK8rNa__delay5",
  "delay6": "ComparisonSection-module__WK8rNa__delay6",
  "fadeInLeft": "ComparisonSection-module__WK8rNa__fadeInLeft",
  "fadeInRight": "ComparisonSection-module__WK8rNa__fadeInRight",
  "fadeInUp": "ComparisonSection-module__WK8rNa__fadeInUp",
  "featureDecoration": "ComparisonSection-module__WK8rNa__featureDecoration",
  "featureIcon": "ComparisonSection-module__WK8rNa__featureIcon",
  "featureIconNormie": "ComparisonSection-module__WK8rNa__featureIconNormie",
  "featureItem": "ComparisonSection-module__WK8rNa__featureItem",
  "featureItemCove": "ComparisonSection-module__WK8rNa__featureItemCove",
  "featureList": "ComparisonSection-module__WK8rNa__featureList",
  "featureListCove": "ComparisonSection-module__WK8rNa__featureListCove",
  "featureListNormie": "ComparisonSection-module__WK8rNa__featureListNormie",
  "featureText": "ComparisonSection-module__WK8rNa__featureText",
  "featureTextCove": "ComparisonSection-module__WK8rNa__featureTextCove",
  "featureTextNormie": "ComparisonSection-module__WK8rNa__featureTextNormie",
  "header": "ComparisonSection-module__WK8rNa__header",
  "headline": "ComparisonSection-module__WK8rNa__headline",
  "phoneDynamicIsland": "ComparisonSection-module__WK8rNa__phoneDynamicIsland",
  "phoneFrame": "ComparisonSection-module__WK8rNa__phoneFrame",
  "phoneFrameNormie": "ComparisonSection-module__WK8rNa__phoneFrameNormie",
  "phoneLabel": "ComparisonSection-module__WK8rNa__phoneLabel",
  "phoneLabelCove": "ComparisonSection-module__WK8rNa__phoneLabelCove",
  "phoneLabelNormie": "ComparisonSection-module__WK8rNa__phoneLabelNormie",
  "phoneName": "ComparisonSection-module__WK8rNa__phoneName",
  "phoneNameCove": "ComparisonSection-module__WK8rNa__phoneNameCove",
  "phoneNameNormie": "ComparisonSection-module__WK8rNa__phoneNameNormie",
  "phoneScreen": "ComparisonSection-module__WK8rNa__phoneScreen",
  "phoneScreenCove": "ComparisonSection-module__WK8rNa__phoneScreenCove",
  "phoneShowcase": "ComparisonSection-module__WK8rNa__phoneShowcase",
  "scaleIn": "ComparisonSection-module__WK8rNa__scaleIn",
  "section": "ComparisonSection-module__WK8rNa__section",
  "subheadline": "ComparisonSection-module__WK8rNa__subheadline",
  "vsBadge": "ComparisonSection-module__WK8rNa__vsBadge",
  "vsBadgeCircle": "ComparisonSection-module__WK8rNa__vsBadgeCircle",
  "vsBadgeText": "ComparisonSection-module__WK8rNa__vsBadgeText",
});
